import validateComponents from 'react-component-validator';
import ProgressStep from './progress-step';
import Component from '@ux/component';
import React from 'react';
import PropTypes from 'prop-types';

const STATUS = ProgressStep.Status;

/**
* Displays progress in steps.
*
* @displayName Progress Steps
* @class ProgressSteps
* @public
*/
class ProgressSteps extends Component {
  /**
   * Get a step's status name based on current progress value.
   *
   * @param {number} idx Step index
   * @returns {string} status
   * @private
   */
  _getStepStatus(idx) {
    let status = STATUS.Incomplete;

    if (idx < this.props.value) {
      status = STATUS.Complete;
    } else if (idx === this.props.value) {
      status = STATUS.Current;
    }
    return status;
  }

  /**
   * Setup the child step elements.
   *
   * @returns {Array} Step children
   * @private
   */
  get _stepElements() {
    const results = [];

    if (this.props.steps) {
      results.push(...this.props.steps.map((name, i) => {
        const idx = i + 1;
        return <ProgressStep key={ idx } status={ this._getStepStatus(idx) }>
          { name }
        </ProgressStep>;
      }));
    }

    if (this.props.children) {
      const offset = results.length + 1;
      results.push(...this.props.children.map((step, i) => {
        const idx = i + offset;
        return React.cloneElement(step, {
          key: idx,
          status: this._getStepStatus(idx),
          tabIndex: idx + this.props.startTabIndex
        });
      }));
    }

    return results;
  }

  /**
   * Renders the component.
   *
   * @returns {React.DOM} Rendered ProgressSteps element.
   * @private
   */
  render() {
    return (
      <div>
        <ul className='ux-tabs-wiz-list'>
          { this._stepElements }
        </ul>
      </div>
    );
  }
}

ProgressSteps.Step = ProgressStep;
ProgressSteps.propTypes = {
  /** Names of each step */
  steps: PropTypes.array,
  /** Current value of each step */
  value: PropTypes.number,
  /** Child React.Components to be displayed underneath */
  children: validateComponents([ProgressStep]),
  /** a11y tab index to start at */
  startTabIndex: PropTypes.number
};

ProgressSteps.defaultProps = {
  value: 1,
  startTabIndex: 0
};

export {
  ProgressSteps as default,
  ProgressStep
};



// WEBPACK FOOTER //
// ./node_modules/@ux/progress-steps/index.js